/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TranscriptionAttempt } from './TranscriptionAttempt';
/**
 * Work selected by the Transcription resource, not by Recording flags.
 */
export type TranscriptionProcessingWork = ({
    kind: TranscriptionProcessingWork.kind;
} | {
    transcriptionId: number;
    kind: TranscriptionProcessingWork.kind;
} | {
    languageCode?: string;
    dualChannel?: boolean;
    providerJobId: string | null;
    duration: number | null;
    audioUrl: string;
    attempt: TranscriptionAttempt;
    kind: TranscriptionProcessingWork.kind;
});
export namespace TranscriptionProcessingWork {
    export enum kind {
        IDLE = 'idle',
    }
}

